import { render, staticRenderFns } from "./number-unit.vue?vue&type=template&id=1f3d3489&scoped=true&"
import script from "./number-unit.vue?vue&type=script&lang=ts&"
export * from "./number-unit.vue?vue&type=script&lang=ts&"
import style0 from "./number-unit.vue?vue&type=style&index=0&id=1f3d3489&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d3489",
  null
  
)

export default component.exports